import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ProjectListPage } from '@/pages/projects/ui/ProjectListPage';
import { paginationSchema, routeValidateQuerySearch } from '@/shared/lib/route';

// URLクエリパラメータのスキーマ
const projectsSearchSchema = paginationSchema.extend({
  year: z.coerce.number().int().optional(),
  project_name: z.string().optional(),
  budget_management_division_ids: z.array(z.string().uuid()).optional(),
  euc_import_master_id: z.string().uuid().optional(),
  tag_ids: z.array(z.string().uuid()).optional(),
});

export const Route = createFileRoute('/_protected/projects/')({
  component: ProjectListPage,
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: true,
      withPaginationSchema: projectsSearchSchema,
      defaultValues: undefined,
    }),
});
